import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { AuthGate } from './components/AuthGate';
import { BottomNav } from './components/BottomNav';
import { Header } from './components/Header';
import { Toasts } from './components/Toasts';
import { useAuth } from './stores/auth';
import { DashboardPage } from './pages/Dashboard';
import { OrdersPage } from './pages/Orders';
import { OrderDetailPage } from './pages/OrderDetail';
import { StatsPage } from './pages/Stats';
import { WorkshopsPage } from './pages/Workshops';
import { SettingsPage } from './pages/Settings';
import { CustomerHomePage } from './pages/CustomerHome';
import { MarketplacePage } from './pages/Marketplace';
import { WorkshopDetailPage } from './pages/WorkshopDetail';
import { MyCarsPage } from './pages/MyCars';
import { MyBookingsPage } from './pages/MyBookings';
import { MyOrdersPage } from './pages/MyOrders';
import { VehiclePassportPage } from './pages/VehiclePassport';
import { SubscriptionPage } from './pages/Subscription';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
      staleTime: 30_000,
    },
  },
});

function RoleHome() {
  const role = useAuth((s) => s.user?.role);
  if (role === 'CUSTOMER') return <CustomerHomePage />;
  return <DashboardPage />;
}

function RoleOrders() {
  const role = useAuth((s) => s.user?.role);
  if (role === 'CUSTOMER') return <MyOrdersPage />;
  return <OrdersPage />;
}

export function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <AuthGate>
          <div className="app">
            <Header />
            <div className="app-body">
              <Routes>
                <Route path="/" element={<RoleHome />} />

                {/* Workshop staff */}
                <Route path="/orders" element={<OrdersPage />} />
                <Route path="/orders/:id" element={<OrderDetailPage />} />
                <Route path="/stats" element={<StatsPage />} />
                <Route path="/workshops" element={<WorkshopsPage />} />

                {/* Customer */}
                <Route path="/marketplace" element={<MarketplacePage />} />
                <Route path="/marketplace/:id" element={<WorkshopDetailPage />} />
                <Route path="/my-cars" element={<MyCarsPage />} />
                <Route path="/my-bookings" element={<MyBookingsPage />} />
                <Route path="/my-orders" element={<MyOrdersPage />} />
                <Route path="/vehicle-passport" element={<VehiclePassportPage />} />

                {/* Shared */}
                <Route path="/settings" element={<SettingsPage />} />
                <Route path="/subscription" element={<SubscriptionPage />} />
                <Route path="*" element={<Navigate to="/" replace />} />
              </Routes>
            </div>
            <BottomNav />
          </div>
          <Toasts />
        </AuthGate>
      </BrowserRouter>
    </QueryClientProvider>
  );
}
